/**
 * util関数
 * 引数の値が正の整数かチェックする
 *
 * @param {int|float|str} str
 * @returns {bool}
 */
export const isNormalInteger = (str) => {
  return str >>> 0 === parseFloat(str);
};

export default isNormalInteger;
